import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function MagnifyIcon({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={size} height={size} viewBox="0 0 18 18">
      <G id="CC" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <G id="zoekbalk" transform="translate(-11.000000, -12.000000)" fill={finalColor} fillRule="nonzero">
          <G id="magnify-(3)" transform="translate(11.000000, 12.000000)">
            <Path
              d="M6.68571429,0 C10.3781323,0 13.3714286,2.99329624 13.3714286,6.68571429 C13.3714286,8.34171429 12.7645714,9.864 11.7668571,11.0365714 L12.0445714,11.3142857 L12.8571429,11.3142857 L18,16.4571429 L16.4571429,18 L11.3142857,12.8571429 L11.3142857,12.0445714 L11.0365714,11.7668571 C9.864,12.7645714 8.34171429,13.3714286 6.68571429,13.3714286 C2.99329624,13.3714286 0,10.3781323 0,6.68571429 C0,2.99329624 2.99329624,0 6.68571429,0 M6.68571429,2.05714286 C4.11428571,2.05714286 2.05714286,4.11428571 2.05714286,6.68571429 C2.05714286,9.25714286 4.11428571,11.3142857 6.68571429,11.3142857 C9.25714286,11.3142857 11.3142857,9.25714286 11.3142857,6.68571429 C11.3142857,4.11428571 9.25714286,2.05714286 6.68571429,2.05714286 Z"
              id="Shape"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}
export default MagnifyIcon;
